// src/lib/tierFeatures.js
// Member-facing description of what each tier unlocks. Used by the
// upgrade celebration so fans see exactly what they just gained.

export const TIER_RANK  = { gold: 1, premium: 2, platinum: 3 }
export const TIER_LABEL = { gold: 'Gold', premium: 'Premium', platinum: 'Platinum' }
export const TIER_TAGLINE = {
  gold: 'The Admirer',
  premium: 'The Companion',
  platinum: 'The Intimate Circle',
}

const FEATURES = [
  { label: 'Personal Chat',   minTier: 'gold',
    detail: t => t === 'gold' ? '24hr window · 4x per month' : 'Unlimited messaging, no timer' },
  { label: 'Ask Me Anything', minTier: 'gold',
    detail: t => t === 'gold' ? '1 question per week' : '2 questions per week' },
  { label: 'Private Vault',   minTier: 'gold',
    detail: t => t === 'platinum' ? 'The full vault — everything unlocked'
               : t === 'premium'  ? 'Gold + Premium exclusive content'
               : 'Gold exclusive content' },
  { label: 'Zangi Messaging', minTier: 'premium',  detail: () => 'Your private Zangi line' },
  { label: 'Private Number',  minTier: 'premium',  detail: () => 'Text directly' },
  { label: 'Voice Calls',     minTier: 'platinum', detail: () => 'Live audio calls' },
  { label: 'Private Dinner',  minTier: 'platinum', detail: () => 'An evening together' },
]

// What a member gains going from one tier to another: brand-new
// features, plus existing features whose limits just got better.
export function gainedFeatures(fromTier, toTier) {
  const from = TIER_RANK[fromTier] || 1
  const to   = TIER_RANK[toTier] || 1
  if (to <= from) return []
  return FEATURES
    .filter(f => {
      const min = TIER_RANK[f.minTier]
      const isNew = min > from && min <= to
      const improved = min <= from && f.detail(fromTier) !== f.detail(toTier)
      return isNew || improved
    })
    .map(f => ({ label: f.label, detail: f.detail(toTier) }))
}
